// Vite entrypoint for the Rails application.
//
// Layered: globals (Bootstrap, Lucide) -> Inspinia theme config -> styles ->
// Hotwire (Turbo Drive + Stimulus) -> Action Cable channels -> globals used by
// controllers (Sortable) -> Inspinia app -> page glue.
//
// Form-field widgets (Choices, Tagify, color picker, date/datetime pickers,
// Toast UI markdown, CodeMirror 6) are lazy-loading Stimulus controllers and are
// NOT imported here. No jQuery, no @rails/ujs.

// =======================================================================
// 1. Globals — must run before Inspinia/plugin scripts that assume them.
// =======================================================================
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

import { createIcons, icons } from 'lucide'
window.lucide = { createIcons: (opts = {}) => createIcons({ icons, ...opts }) }

// =======================================================================
// 2. Inspinia theme config — sets data-* on <html> synchronously (avoids FOUC).
// =======================================================================
import '../inspinia/config.js'

// =======================================================================
// 3. Stylesheets — Inspinia core + plugin base CSS + app overrides.
// =======================================================================
import '../scss/application.scss'

// =======================================================================
// 4. Hotwire — Turbo (Drive enabled) and Stimulus.
//    Turbo Drive owns navigation and handles data-turbo-method / data-turbo-confirm.
//    Destructive actions use `data: { turbo_method:, turbo_confirm: }` or `button_to`.
// =======================================================================
import { Turbo } from '@hotwired/turbo-rails'
window.Turbo = Turbo

import '../controllers/index.js'

// Sidenav active-link highlighting across Turbo Drive visits (sidenav is data-turbo-permanent).
import '../app/sidenav_active.js'

// Custom Bootstrap confirm dialog for data-turbo-confirm (replaces window.confirm).
import '../app/turbo_confirm.js'

// =======================================================================
// 5. Action Cable channels — auto-register via glob import.
// =======================================================================
import.meta.glob('../channels/*_channel.js', { eager: true })

// =======================================================================
// 6. SortableJS — used as a global by the sortable/kanban Stimulus controllers.
// =======================================================================
import Sortable from 'sortablejs'
window.Sortable = Sortable

// =======================================================================
// 7. Inspinia app.js — sidenav, topbar, theme toggle, form validation, etc.
//    Dynamic import ensures the globals above are set before it runs.
// =======================================================================
await import('../inspinia/app.js')

// =======================================================================
// 8. Page glue — filter/search helpers, keyboard shortcuts, sidebar minimize
//    toggle, clipboard helpers (vanilla JS, runs once per Turbo visit).
// =======================================================================
await import('../app/init_legacy_sprockets.js')
